module.exports = __webpack_public_path__ + "img/icon-money.e010310a.svg";